<template>
  <div class="error-page">
    <circle-stage>
      <template slot="headline">
        <no-wifi-icon class="icon" />
        {{ $t('ErrorNetwork.headline') }}
      </template>

      <p>
        {{ $t('ErrorNetwork.message') }}
      </p>
    </circle-stage>

    <div class="instructions">
      <div class="content">
        <div class="step">
          <span>1.</span>
          <span v-html="$t('ErrorNetwork.steps.connect')" />
        </div>

        <div class="info-container">
          <div class="step">
            <span>2.</span>
            <span v-html="$t('ErrorNetwork.steps.deactivate')" />
          </div>

          <div class="row-container">
            <info-icon class="info-icon"></info-icon>
            <div class="info">
              <span>{{ $t('ErrorNetwork.steps.relayInfo') }}</span>
              <span v-html="$t('ErrorNetwork.steps.howToDeactivate')" />
            </div>
          </div>
        </div>

      </div>

      <a class="button" :href="retryUrl">{{ $t('ErrorNetwork.steps.retry') }}</a>

      <div class="support-container">
        <span style="font-weight: bold">
          {{ $t('ErrorNetwork.steps.help') }}
        </span>

        <span>
          {{ $t('ErrorNetwork.steps.support') }}
        </span>
      </div>
    </div>

  </div>
</template>

<script>
import env from '@/env';
import CircleStage from '@/components/CircleStage/CircleStage.vue';
import NoWifiIcon from '@/components/icons/NoWifiIcon.vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';

export default {
  name: 'ErrorNetwork',
  components: {
    InfoIcon,
    NoWifiIcon,
    CircleStage,
  },
  computed: {
    retryUrl: (vm) => {
      const { tenant, locale } = vm.$route.params;
      const code = vm.$route.params.authenticationCode;
      if (code) {
        return `${env.RETRY_URL}/${tenant}/${locale}/processing/${code}`;
      }
      return `${env.RETRY_URL}/${tenant}/${locale}/manual`;
    },
  },
  methods: {
    retry() {
      // eslint-disable-next-line no-restricted-globals
      location.href = this.retryUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.error-page {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .icon {
    display: block;
    width: 100px;
    margin: 0 auto var(--spacing-side);
  }

  .info-icon {
    width: 40px;
  }

  .instructions {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    max-width: var(--spacing-width-max);
    margin-left: auto;
    margin-right: auto;
    gap: 24px;
    padding: var(--spacing-side);

    .button {
      background-color: var(--colors-primary);
      color: var(--colors-main-font);
      text-decoration: none;
      border: none;
      text-align: center;
      padding: 16px;
      border-radius: 16px;
      font-weight: bold;
      letter-spacing: 0.1rem;
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: 12px;
      justify-content: center;
      max-width: var(--spacing-width-max);
      text-align: center;
      width: 90%;
      margin-left: auto;
      margin-right: auto;

      .row-container {
        display:flex;
        flex-direction: row;
        align-items: center;
        gap:  var(--spacing-side);
        padding: 16px;
      }

      .info-container {
        display: flex;
        flex-direction: column;
        border-radius: 16px;
        background-color: var(--colors-primary-lightened);

        .info {
          display: flex;
          flex-direction: column;
          gap: 12px;
          font-size: 0.8rem;
          text-align: left;
          line-height: 1.5;
        }
      }

      .step {
        display: flex;
        flex-direction: row;
        gap: 16px;
        background-color: var(--colors-primary-dimmed);
        border-radius: 16px;
        padding: 16px;
        text-align: left;
      }
    }

    .support-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      padding: 16px;
      color: var(--colors-secondary-font);
    }
  }
}
</style>
